import _ from "@lodash";
import { Badge, Button, Fab, IconButton, Typography, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import React from "react";
import { AiFillDislike, AiFillLike, AiFillLock, AiFillSafetyCertificate, AiFillSkype, AiFillUnlock, AiOutlineDelete, AiOutlineFullscreen, AiOutlineFullscreenExit, AiOutlineGlobal, AiOutlineMergeCells, AiOutlineSafetyCertificate } from "react-icons/ai";
import { BiCalendarEdit, BiFileBlank, BiGridVertical, BiRun, BiTask, BiUpload } from "react-icons/bi";
import { BsBuildings, BsCardHeading, BsCardText, BsChatQuoteFill, BsChatSquareDotsFill, BsFileBarGraph, BsFileEarmarkLockFill, BsFillChatLeftTextFill, BsFillPersonLinesFill, BsFolderPlus, BsHeadset, BsImage, BsLayersFill, BsPaperclip, BsPersonLinesFill } from "react-icons/bs";
import { CgPlayListSearch, CgSandClock } from "react-icons/cg";
import { FaAddressCard, FaBox, FaBriefcaseMedical, FaClinicMedical, FaFileInvoiceDollar, FaFileSignature, FaHandHolding, FaKey, FaLayerGroup, FaMapMarkerAlt, FaRegCalendarAlt, FaRegCalendarCheck, FaRegCalendarMinus, FaRegCalendarPlus, FaRegCalendarTimes, FaRegLightbulb, FaStackOverflow, FaStickyNote, FaTrashAlt, FaUserCog, FaVideo, FaWpforms } from "react-icons/fa";
import { FiCreditCard, FiMail, FiMoreVertical, FiPhone, FiPrinter, FiShoppingCart, FiUserCheck } from "react-icons/fi";
import { GiCatch, GiConfirmed, GiFairyWand, GiMedicines, GiPerson, GiReceiveMoney, GiSyringe } from "react-icons/gi";
import { GoGraph, GoInfo, GoRequestChanges } from "react-icons/go";
import { GrDocumentDownload } from "react-icons/gr";
import { HiOutlineArrowNarrowRight, HiOutlineExternalLink, HiOutlineRefresh, HiOutlineViewList } from "react-icons/hi";
import { ImBarcode, ImExit, ImWhatsapp } from "react-icons/im";
import { IoIosBug, IoIosPaper, IoMdArrowBack, IoMdCheckboxOutline, IoMdEye, IoMdHome, IoMdNavigate, IoMdPersonAdd, IoMdReturnLeft, IoMdShare } from "react-icons/io";
import { MdAccountCircle, MdAdd, MdAddShoppingCart, MdApps, MdArchive, MdArrowBack, MdArrowForward, MdAttachMoney, MdBallot, MdBlock, MdCancel, MdClose, MdCloudDownload, MdCloudUpload, MdDelete, MdDone, MdDoneAll, MdEdit, MdFormatListNumbered, MdGetApp, MdGroups, MdHelpOutline, MdImportantDevices, MdKeyboardArrowDown, MdKeyboardArrowLeft, MdKeyboardArrowRight, MdKeyboardArrowUp, MdLabel, MdLocalShipping, MdLogin, MdLogout, MdMenu, MdMonetizationOn, MdMoveToInbox, MdNotifications, MdNotificationsActive, MdOpenInNew, MdOutlineChecklist, MdOutlineLocalShipping, MdOutlinePortrait, MdOutlineQueue, MdPersonOff, MdPlayArrow, MdPortrait, MdPublish, MdSave, MdSearch, MdSend, MdSentimentDissatisfied, MdSentimentSatisfied, MdSettings, MdStar, MdStarOutline, MdStore, MdStoreMallDirectory, MdToday, MdUnarchive, MdViewArray, MdViewDay, MdViewModule, MdViewWeek, MdWarning, MdWeb } from "react-icons/md";
import { RiCake2Line, RiFilterFill, RiFilterOffFill, RiGroupLine, RiImageAddFill, RiLayoutColumnLine, RiLightbulbFlashLine, RiPlayListAddFill, RiPushpinFill, RiTimerLine, RiUserAddLine, RiUserSettingsLine } from "react-icons/ri";
import { TiMinus } from "react-icons/ti";
import { VscClearAll } from "react-icons/vsc";
import XAPPTooltip from "../Tooltip/XAPPTooltip";


const styles = theme => ({
    board: {
        cursor: "pointer",
        boxShadow: theme.shadows[0],
        transitionProperty: "box-shadow border-color",
        transitionDuration: theme.transitions.duration.short,
        transitionTimingFunction: theme.transitions.easing.easeInOut,
        background: theme.palette.primary.dark,
        color: "#FFF",
        "&:hover": {
            boxShadow: theme.shadows[6]
        },
        "&:focus": {
            boxShadow: theme.shadows[6]
        }
    },
    noHover: {
        "&:hover": {
            background: "none",
        }
    }
});

class XAPPButton extends XAPPComponent {

    constructor(props) {
        super(props);
        this.DialogOnly = props.DialogOnly;
        this.fluxo = props.fluxo;
        this.state = { wait: false };
    }

    getIcon = (_AIcon) => {
        switch (_AIcon) {// 
            case "user_add": return <RiUserAddLine className={clsx("text-20", this.props.iconProps)} />;
            case "merge": return <AiOutlineMergeCells className={clsx("text-20", this.props.iconProps)} />;
            case "devices": return <MdImportantDevices className={clsx("text-20", this.props.iconProps)} />;
            case "headset": return <BsHeadset className={clsx("text-20", this.props.iconProps)} />;
            case "menu": return <MdMenu className={clsx("text-20", this.props.iconProps)} />;
            case "drag_drop": return <BiGridVertical className={clsx("text-20", this.props.iconProps)} />;
            case "arrow_large_right": return <HiOutlineArrowNarrowRight className={clsx("text-20", this.props.iconProps)} />;
            case "checkbox": return <IoMdCheckboxOutline className={clsx("text-20", this.props.iconProps)} />;
            case "user_settings": return <RiUserSettingsLine className={clsx("text-20", this.props.iconProps)} />;
            case "file_cifrao": return <FaFileInvoiceDollar className={clsx("text-20", this.props.iconProps)} />;
            case "confirmado": return <GiConfirmed className={clsx("text-20", this.props.iconProps)} />;
            case "exit": return <ImExit className={clsx("text-20", this.props.iconProps)} />;
            case "website": return <AiOutlineGlobal className={clsx("text-20", this.props.iconProps)} />;
            case "observacao": return <BsChatSquareDotsFill className={clsx("text-20", this.props.iconProps)} />;
            case "label": return <MdLabel className={clsx("text-20", this.props.iconProps)} />;
            case "lampada_flash": return <RiLightbulbFlashLine className={clsx("text-20", this.props.iconProps)} />;
            case "warning": return <MdWarning className={clsx("text-20", this.props.iconProps)} />;
            case "birthday": return <RiCake2Line className={clsx("text-20", this.props.iconProps)} />;
            case "no_notify": return <MdNotifications className={clsx("text-20", this.props.iconProps)} />;
            case "notify": return <MdNotificationsActive className={clsx("text-20", this.props.iconProps)} />;
            case "alfinete": return <RiPushpinFill className={clsx("text-20", this.props.iconProps)} />;
            case "open_new": return <MdOpenInNew className={clsx("text-20", this.props.iconProps)} />;
            case "cartao_blank": return <FiCreditCard className={clsx("text-20", this.props.iconProps)} />;
            case "tarefa": return <BiTask className={clsx("text-20", this.props.iconProps)} />;
            case "file_blank": return <BiFileBlank className={clsx("text-20", this.props.iconProps)} />;
            case "card_text": return <BsCardText className={clsx("text-20", this.props.iconProps)} />;
            case "graph": return <GoGraph className={clsx("text-20", this.props.iconProps)} />;
            case "graph_bar": return <BsFileBarGraph className={clsx("text-20", this.props.iconProps)} />;
            case "help": return <MdHelpOutline className={clsx("text-20", this.props.iconProps)} />;
            case "dica": return <FaRegLightbulb className={clsx("text-16", this.props.iconProps)} />;
            case "boleto": return <ImBarcode className={clsx("text-20", this.props.iconProps)} />;
            case "apps": return <MdApps className={clsx("text-20", this.props.iconProps)} />;
            case "cadastro": return <MdStore className={clsx("text-20", this.props.iconProps)} />;
            case "suprimentos": return <MdOutlineLocalShipping className={clsx("text-20", this.props.iconProps)} />;
            case "atendimento": return <MdOutlinePortrait className={clsx("text-20", this.props.iconProps)} />;
            case "lista_numerada": return <MdFormatListNumbered className={clsx("text-20", this.props.iconProps)} />;
            case "retrato": return <MdPortrait className={clsx("text-20", this.props.iconProps)} />;
            case "profile": return <MdAccountCircle className={clsx("text-20", this.props.iconProps)} />;
            case "atestado": return <AiOutlineSafetyCertificate className={clsx("text-20", this.props.iconProps)} />;
            case "atestado_cid": return <AiFillSafetyCertificate className={clsx("text-20", this.props.iconProps)} />;
            case "declaracao": return <FiUserCheck className={clsx("text-20", this.props.iconProps)} />;
            case "atestado_acompanhante": return <RiGroupLine className={clsx("text-20", this.props.iconProps)} />;
            case "exame": return <FaClinicMedical className={clsx("text-20", this.props.iconProps)} />;
            case "triagem": return <MdOutlineQueue className={clsx("text-20", this.props.iconProps)} />;
            case "receita": return <GiMedicines className={clsx("text-20", this.props.iconProps)} />;
            case "receita_controlada": return <BsFileEarmarkLockFill className={clsx("text-20", this.props.iconProps)} />;
            case "procedimento_medico": return <GiSyringe className={clsx("text-20", this.props.iconProps)} />;
            case "paper": return <IoIosPaper className={clsx("text-20", this.props.iconProps)} />;
            case "checklist_add": return <RiPlayListAddFill className={clsx("text-20", this.props.iconProps)} />;
            case "checklist": return <MdOutlineChecklist className={clsx("text-20", this.props.iconProps)} />;
            case "column": return <RiLayoutColumnLine className={clsx("text-20", this.props.iconProps)} />;
            case "more_vertical": return <FiMoreVertical className={clsx("text-20", this.props.iconProps)} />;
            case "forms": return <FaWpforms className={clsx("text-20", this.props.iconProps)} />;
            case "recebido": return <GiReceiveMoney className={clsx("text-20", this.props.iconProps)} />;
            case "notes": return <FaStickyNote className={clsx("text-20", this.props.iconProps)} />;
            case "arquivar": return <MdArchive className={clsx("text-20", this.props.iconProps)} />;
            case "desarquivar": return <MdUnarchive className={clsx("text-20", this.props.iconProps)} />;
            case "like": return <AiFillLike className={clsx("text-20", this.props.iconProps)} />;
            case "dislike": return <AiFillDislike className={clsx("text-20", this.props.iconProps)} />;
            case "person_off": return <MdPersonOff className={clsx("text-20", this.props.iconProps)} />;
            case "ampulheta": return <CgSandClock className={clsx("text-20", this.props.iconProps)} />;
            case "calendar_done": return <FaRegCalendarCheck className={clsx("text-20", this.props.iconProps)} />;
            case "run": return <BiRun className={clsx("text-20", this.props.iconProps)} />;
            case "calendar_minus": return <FaRegCalendarMinus className={clsx("text-20", this.props.iconProps)} />;
            case "calendar_close": return <FaRegCalendarTimes className={clsx("text-20", this.props.iconProps)} />;
            case "login": return <MdLogin className={clsx("text-20", this.props.iconProps)} />;
            case "logout": return <MdLogout className={clsx("text-20", this.props.iconProps)} />;
            case "full_screen": return <AiOutlineFullscreen className={clsx("text-20", this.props.iconProps)} />;
            case "exit_full_screen": return <AiOutlineFullscreenExit className={clsx("text-20", this.props.iconProps)} />;
            case "filtro": return <RiFilterFill className={clsx("text-20", this.props.iconProps)} />;
            case "remove_filtro": return <RiFilterOffFill className={clsx("text-20", this.props.iconProps)} />;
            case "view_day": return <MdViewDay className={clsx("text-20", this.props.iconProps)} />;
            case "view_array": return <MdViewArray className={clsx("text-20", this.props.iconProps)} />;
            case "view_week": return <MdViewWeek className={clsx("text-20", this.props.iconProps)} />;
            case "view_module": return <MdViewModule className={clsx("text-20", this.props.iconProps)} />;
            case "hoje": return <MdToday className={clsx("text-20", this.props.iconProps)} />;
            case "pessoacard": return <FaAddressCard className={clsx("text-20", this.props.iconProps)} />;
            case "userconfig": return <FaUserCog className={clsx("text-20", this.props.iconProps)} />;
            case "building": return <BsBuildings className={clsx("text-20", this.props.iconProps)} />;
            case "shopping": return <FiShoppingCart className={clsx("text-20", this.props.iconProps)} />;
            case "stack_overflow": return <FaStackOverflow className={clsx("text-20", this.props.iconProps)} />;
            case "mao_aberta": return <FaHandHolding className={clsx("text-20", this.props.iconProps)} />;
            case "carrinho": return <FiShoppingCart className={clsx("text-20", this.props.iconProps)} />;
            case "phone": return <FiPhone className={clsx("text-20", this.props.iconProps)} />;
            case "link_externo": return <HiOutlineExternalLink className={clsx("text-20", this.props.iconProps)} />;
            case "wizard": return <GiFairyWand className={clsx("text-20", this.props.iconProps)} />;
            case "add_folder": return <BsFolderPlus className={clsx("text-20", this.props.iconProps)} />;
            case "file_download": return <GrDocumentDownload className={clsx("text-20", this.props.iconProps)} />;
            case "searchList": return <CgPlayListSearch className={clsx("text-20", this.props.iconProps)} />;
            case "alterAgenda": return <BiCalendarEdit className={clsx("text-20", this.props.iconProps)} />;
            case "cardHead": return <BsCardHeading className={clsx("text-20", this.props.iconProps)} />;
            case "searchPerson": return <BsFillPersonLinesFill className={clsx("text-20", this.props.iconProps)} />;
            case "email": return <FiMail className={clsx("text-20", this.props.iconProps)} />;
            case "whatsapp": return <ImWhatsapp className={clsx("text-20", this.props.iconProps)} />;
            case "upload": return <BiUpload className={clsx("text-20", this.props.iconProps)} />;
            case "shopping_add": return <MdAddShoppingCart className={clsx("text-20", this.props.iconProps)} />;
            case "file": return <BsPaperclip className={clsx("text-20", this.props.iconProps)} />;
            case "image": return <BsImage className={clsx("text-20", this.props.iconProps)} />;
            case "image_add": return <RiImageAddFill className={clsx("text-20", this.props.iconProps)} />;
            case "lock": return <AiFillLock className={clsx("text-20", this.props.iconProps)} />;
            case "unlock": return <AiFillUnlock className={clsx("text-20", this.props.iconProps)} />;
            case "list": return <HiOutlineViewList className={clsx("text-20", this.props.iconProps)} />;
            case "key": return <FaKey className={clsx("text-20", this.props.iconProps)} />;
            case "hangouts": return <BsChatQuoteFill className={clsx("text-20", this.props.iconProps)} />;
            case "skype": return <AiFillSkype className={clsx("text-20", this.props.iconProps)} />;
            case "navigate": return <IoMdNavigate className={clsx("text-20", this.props.iconProps)} />;
            case "edit": return <MdEdit className={clsx("text-20", this.props.iconProps)} />;
            case "share": return <IoMdShare className={clsx("text-20", this.props.iconProps)} />;
            case "insumo": return <MdMoveToInbox className={clsx("text-20", this.props.iconProps)} />;
            case "produto": return <FaBox className={clsx("text-20", this.props.iconProps)} />;
            case "info": return <GoInfo className={clsx("text-20", this.props.iconProps)} />;
            case "block": return <MdBlock className={clsx("text-20", this.props.iconProps)} />;
            case "layerfill": return <BsLayersFill className={clsx("text-20", this.props.iconProps)} />;
            case "layergroup": return <FaLayerGroup className={clsx("text-20", this.props.iconProps)} />;
            case "request": return <GoRequestChanges className={clsx("text-20", this.props.iconProps)} />;
            case "timer": return <RiTimerLine className={clsx("text-20", this.props.iconProps)} />;
            case "cifrao": return <MdAttachMoney className={clsx("text-20", this.props.iconProps)} />;
            case "person_add": return <IoMdPersonAdd className={clsx("text-20", this.props.iconProps)} />;
            case "personlines": return <BsPersonLinesFill className={clsx("text-20", this.props.iconProps)} />;
            case "clear": return <VscClearAll className={clsx("text-20", this.props.iconProps)} />;
            case "agendamento": return <FaRegCalendarPlus className={clsx("text-20", this.props.iconProps)} />;
            case "arrow_down": return <MdKeyboardArrowDown className={clsx("text-20", this.props.iconProps)} />;
            case "arrow_up": return <MdKeyboardArrowUp className={clsx("text-20", this.props.iconProps)} />;
            case "arrow_right": return <MdKeyboardArrowRight className={clsx("text-20", this.props.iconProps)} />;
            case "arrow_left": return <MdKeyboardArrowLeft className={clsx("text-20", this.props.iconProps)} />;
            case "rollback": return <IoMdArrowBack className={clsx("text-20", this.props.iconProps)} />;
            case "signature": return <FaFileSignature className={clsx("text-20", this.props.iconProps)} />;
            case "home": return <IoMdHome className={clsx("text-20", this.props.iconProps)} />;
            case "refresh": return <HiOutlineRefresh className={clsx("text-20", this.props.iconProps)} />;
            case "person": return <GiPerson className={clsx("text-20", this.props.iconProps)} />;
            case "mapMarker": return <FaMapMarkerAlt className={clsx("text-20", this.props.iconProps)} />;
            case "trash": return <FaTrashAlt className={clsx("text-20", this.props.iconProps)} />;
            case "eye": return <IoMdEye className={clsx("text-20", this.props.iconProps)} />;
            case "calendar": return <FaRegCalendarAlt className={clsx("text-20", this.props.iconProps)} />;
            case "casemedical": return <FaBriefcaseMedical className={clsx("text-20", this.props.iconProps)} />;
            case "video": return <FaVideo className={clsx("text-20", this.props.iconProps)} />;
            case "publish": return <MdPublish className={clsx("text-20", this.props.iconProps)} />;
            case "send": return <MdSend className={clsx("text-20", this.props.iconProps)} />;
            case "star": return <MdStar className={clsx("text-20", this.props.iconProps)} />;
            case "no_star": return <MdStarOutline className={clsx("text-20", this.props.iconProps)} />;
            case "web": return <MdWeb className={clsx("text-20", this.props.iconProps)} />;
            case "done_all": return <MdDoneAll className={clsx("text-20", this.props.iconProps)} />;
            case "done": return <MdDone className={clsx("text-20", this.props.iconProps)} />;
            case "close": return <MdClose className={clsx("text-20", this.props.iconProps)} />;
            case "search": return <MdSearch className={clsx("text-20", this.props.iconProps)} />;
            case "dissatisfied": return <MdSentimentDissatisfied className={clsx("text-20", this.props.iconProps)} />;
            case "satisfied": return <MdSentimentSatisfied className={clsx("text-20", this.props.iconProps)} />;
            case "add": return <MdAdd className={clsx("text-20", this.props.iconProps)} />;
            case "delete": return <MdDelete className={clsx("text-20", this.props.iconProps)} />;
            case "delete_line": return <AiOutlineDelete className={clsx("text-20", this.props.iconProps)} />;
            case "save": return <MdSave className={clsx("text-20", this.props.iconProps)} />;
            case "cloud_upload": return <MdCloudUpload className={clsx("text-20", this.props.iconProps)} />;
            case "cloud_download": return <MdCloudDownload className={clsx("text-20", this.props.iconProps)} />;
            case "print": return <FiPrinter className={clsx("text-20", this.props.iconProps)} />;
            case "get_app": return <MdGetApp className={clsx("text-20", this.props.iconProps)} />;
            case "cancel": return <MdCancel className={clsx("text-20", this.props.iconProps)} />;
            case "arrow_forward": return <MdArrowForward className={clsx("text-20", this.props.iconProps)} />;
            case "arrow_back": return <MdArrowBack className={clsx("text-20", this.props.iconProps)} />;
            case "play_arrow": return <MdPlayArrow className={clsx("text-20", this.props.iconProps)} />;
            case "catch": return <GiCatch className={clsx("text-20", this.props.iconProps)} />;
            case "return": return <IoMdReturnLeft className={clsx("text-20", this.props.iconProps)} />;
            case "chat": return <BsFillChatLeftTextFill className={clsx("text-20", this.props.iconProps)} />;
            case "bug": return <IoIosBug className={clsx("text-20", this.props.iconProps)} />;
            case "minus": return <TiMinus className={clsx("text-20", this.props.iconProps)} />;
            case "store_mall_directory": return <MdStoreMallDirectory className={clsx("text-20", this.props.iconProps)} />;
            case "local_shipping": return <MdLocalShipping className={clsx("text-20", this.props.iconProps)} />;
            case "monetization_on": return <MdMonetizationOn className={clsx("text-20", this.props.iconProps)} />;
            case "ballot": return <MdBallot className={clsx("text-20", this.props.iconProps)} />;
            case "groups": return <MdGroups className={clsx("text-20", this.props.iconProps)} />;
            case "settings": return <MdSettings className={clsx("text-20", this.props.iconProps)} />;
            case null:
            case undefined: return "";
            default: return <Typography className={"text-16 leading-none " + this.props.iconProps}>{_AIcon[0]}</Typography>;
        }
    };

    onClick = (ev) => {
        if (this.state.wait) {
            return;
        }
        this.setState({ wait: true });
        setTimeout(() => this.setState({ wait: false }), 1000);
        if (!_.isUndefined(this.props.onClick) && !_.isNull(this.props.onClick)) {
            this.props.onClick(ev);
        }
    };

    render() {
        const { badge, tooltip = null, variant, className, label, disabled, icon = null, size, key, color, type, classes, id, noHover = false,
            component, rel, target, href, children, ariaOwns, ariaHaspopup } = this.props;
        if (type) {
            switch (type.toUpperCase()) {
                case "FAB":
                    if (tooltip !== null) {
                        return (
                            <XAPPTooltip title={tooltip.title} placement={tooltip.placement}>
                                <Fab
                                    className={clsx(className, noHover && classes.noHover)}
                                    onClick={(ev) => this.onClick(ev)}
                                    variant={variant}
                                    size={size}
                                    color={color}
                                    key={key}
                                    id={id}
                                    disabled={disabled || this.state.wait}
                                    href={href}
                                    target={target}
                                    rel={rel}
                                    component={component}
                                >
                                    {icon !== null && this.getIcon(icon)}
                                </Fab>
                            </XAPPTooltip>
                        );
                    }
                    else {
                        return (
                            <React.Fragment>
                                <Fab
                                    className={clsx(className, noHover && classes.noHover)}
                                    onClick={(ev) => this.onClick(ev)}
                                    variant={variant}
                                    size={size}
                                    color={color}
                                    key={key}
                                    id={id}
                                    disabled={disabled || this.state.wait}
                                    href={href}
                                    target={target}
                                    rel={rel}
                                    component={component}
                                >
                                    {icon !== null && this.getIcon(icon)}
                                </Fab>
                            </React.Fragment>
                        );
                    }
                case "SUBMIT":
                    return (
                        <React.Fragment>
                            <Button
                                className={clsx(className, noHover && classes.noHover)}
                                onClick={(ev) => this.onClick(ev)}
                                variant={variant}
                                size={size}
                                color={color}
                                key={key}
                                id={id}
                                type={"submit"}
                                disabled={disabled || this.state.wait}
                                href={href}
                                target={target}
                                rel={rel}
                                component={component}
                            >
                                {icon !== null && this.getIcon(icon)}
                                <span className="leading-none">{label}</span>
                            </Button>
                        </React.Fragment>
                    );
                case "BUTTON":
                    return (
                        <React.Fragment>
                            <Button
                                className={clsx(className, noHover && classes.noHover)}
                                onClick={(ev) => this.onClick(ev)}
                                variant={variant}
                                size={size}
                                color={color}
                                key={key}
                                id={id}
                                disabled={disabled || this.state.wait}
                                href={href}
                                target={target}
                                rel={rel}
                                component={component}
                            >
                                {icon !== null && this.getIcon(icon)}
                                <span className="leading-none">{label}</span>
                                {children}
                            </Button>
                        </React.Fragment>
                    );
                case "ICON":
                    if (!_.isNull(tooltip)) {
                        return (
                            <React.Fragment>
                                <XAPPTooltip title={tooltip.title} placement={tooltip.placement}>
                                    <IconButton
                                        className={clsx(className, noHover && classes.noHover)}
                                        onClick={(ev) => this.onClick(ev)}
                                        variant={variant}
                                        size={size}
                                        color={color}
                                        key={key}
                                        id={id}
                                        disabled={disabled || this.state.wait}
                                        href={href}
                                        target={target}
                                        rel={rel}
                                        component={component}
                                        aria-owns={ariaOwns}
                                        aria-haspopup={ariaHaspopup}
                                    >
                                        <Badge
                                            badgeContent={badge ? badge : 0}
                                            color="error"
                                        >
                                            {icon !== null ? this.getIcon(icon) : children}
                                        </Badge>
                                    </IconButton>
                                </XAPPTooltip>
                            </React.Fragment>
                        );
                    }
                    else {
                        return (
                            <React.Fragment>
                                <IconButton
                                    className={clsx(className, noHover && classes.noHover)}
                                    onClick={(ev) => this.onClick(ev)}
                                    variant={variant}
                                    size={size}
                                    color={color}
                                    key={key}
                                    id={id}
                                    disabled={disabled || this.state.wait}
                                    href={href}
                                    target={target}
                                    rel={rel}
                                    component={component}
                                >
                                    <Badge
                                        badgeContent={badge ? badge : 0}
                                        color="error"
                                    >
                                        {icon !== null ? this.getIcon(icon) : children}
                                    </Badge>
                                </IconButton>
                            </React.Fragment>
                        );
                    }
                case "CARD":
                    return (
                        <React.Fragment>
                            <div className="w-180 h-160 p-16" key={"02"}>
                                <button
                                    className={clsx(classes.board, "flex flex-col items-center justify-center w-full rounded h-full", className)}
                                    role="button"
                                    onClick={(ev) => this.onClick(ev)}
                                >
                                    {icon !== null && this.getIcon(icon)}
                                    <Typography
                                        className="text-15 font-300 text-center pt-16 px-32"
                                        color="inherit"
                                    >
                                        {label}
                                    </Typography>
                                </button>
                            </div>
                        </React.Fragment>
                    );
                default:
                    return (
                        <div>Type não encontrado para esse Button</div>
                    );
            }
        }
        else {
            return (
                <div>Você esqueceu de definir o type do Button</div>
            );
        }
    }
}


export default withStyles(styles, { withTheme: true })(XAPPButton);

